import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import {
    initialUIState,
    initialUIStatePrio,
    IUIState,
    IUIStatePrio,
} from './IUIState';
import { UIActions } from './UIActions';
import {
    hidePopup,
    hidePrioPopup,
    openMenu,
    showPopup,
    showPrioPopup,
} from './UIStateHelper';

export const UIReducer: Reducer<IUIState> = (
    state: IUIState = initialUIState,
    action: ActionType<typeof UIActions>
) => {
    switch (action.type) {
        case getType(UIActions.showPopup):
            state = showPopup(
                state,
                action.payload.popupID,
                action.payload.params,
                action.payload.crumb
            );
            break;
        case getType(UIActions.hidePopup):
            state = hidePopup(
                state,
                action.payload.popupID,
                action.payload.params
            );
            break;
        case getType(UIActions.openMenu):
            state = openMenu(state, action.payload);
    }
    return state;
};

export const UIReducerPrio: Reducer<IUIStatePrio> = (
    state: IUIStatePrio = initialUIStatePrio,
    action: ActionType<typeof UIActions>
) => {
    switch (action.type) {
        case getType(UIActions.showPrioPopup):
            state = showPrioPopup(
                state,
                action.payload.popupID,
                action.payload.params
            );
            break;
        case getType(UIActions.hidePrioPopup):
            state = hidePrioPopup(
                state,
                action.payload.popupID,
                action.payload.params
            );
            break;
    }
    return state;
};
